// extracted by mini-css-extract-plugin
export default {"banner":"PromoBadge-banner_CPDUg","highlight":"PromoBadge-highlight_eoUOY","sparkle":"PromoBadge-sparkle_XfsC1"};